export default __webpack_public_path__ + "static/media/electricBike.fadafbb9.svg";